import { notifications } from "@mantine/notifications";

export enum NotificationType {
  Success = "success",
  Error = "error",
  Warning = "warning",
  Info = "info",
}
interface INotifications {
  withCloseButton?: boolean;
  autoClose?: number | boolean;
  title: string;
  message: string;
  type: NotificationType;
}

const getColorBaseOnType = (type: NotificationType) => {
  switch (type) {
    case NotificationType.Success:
      return "green";
    case NotificationType.Error:
      return "red";
    case NotificationType.Warning:
      return "yellow";
    case NotificationType.Info:
      return "blue";
    default:
      return "blue";
  }
};

export const showNotification = (props: INotifications) => {
  const {
    withCloseButton = true,
    autoClose = false,
    title,
    message,
    type,
  } = props;
  notifications.show({
    withCloseButton,
    autoClose,
    title,
    message,
    color: getColorBaseOnType(type),
  });
};
